export const actionKey = '@@uploads';

//# sourceMappingURL=constants.js.map